export const TEST_IDS = {
  navHome: "nav-home-link",
  navGallery: "nav-gallery-link",
  startCameraBtn: "start-camera-btn",
  uploadPhotoBtn: "upload-photo-btn",
  fileInput: "file-input",
  cameraVideo: "camera-video",
  captureBtn: "capture-btn",
  retakeBtn: "retake-btn",
  categorySelect: "category-select",
  generateBtn: "generate-sticker-btn",
  generatingIndicator: "generating-indicator",
  stickerPreview: "sticker-preview",
  stickerPhrase: "sticker-phrase",
  downloadBtn: "download-sticker-btn",
  shareBtn: "share-sticker-btn",
  newStickerBtn: "new-sticker-btn",
  galleryGrid: "gallery-grid",
  galleryItem: "gallery-item",
  galleryEmpty: "gallery-empty",
  errorAlert: "error-alert",
};
